import React from 'react';
// STYLE
import Button from '@material-ui/core/Button';

const ViewMyReservationButton = props => {
  const { reservationOnItemByUser, setReservationData } = props;
  return (
    <Button
      size="small"
      color="primary"
      onClick={() => setReservationData(reservationOnItemByUser)}
      variant="outlined"
    >
      Foglalásom megtekintése
    </Button>
  );
};

export default ViewMyReservationButton;
